import { state, debugLog } from "./state.js";
import type { EventData, EventPayload } from "./types.js";

const STANDARD_EVENTS = new Set(["PageView", "ViewContent", "Search", "AddToCart", "InitiateCheckout", "AddPaymentInfo", "Purchase"]);
export const SHOPIFY_CONTEXT_EVENT = "the_social_tap:context";

export function isShopifyContextCapture(data: EventData | undefined): boolean {
  if (!state.config?.platforms?.shopify?.appCollector) return false;
  if (!data?.eventName && data?.trackingRuleId) return false;
  return STANDARD_EVENTS.has(data?.eventName || "PageView");
}

/** Publish opaque routing identifiers, never customer hashes, on Shopify's event bus. */
export function publishShopifyContext(payload: EventPayload, ready: boolean): void {
  const analytics = window.Shopify?.analytics;
  if (!analytics) return;
  try {
    void Promise.resolve(analytics.publish(SHOPIFY_CONTEXT_EVENT, {
      contextId: payload.eventId, websiteId: state.websiteId,
      eventName: payload.eventName || "PageView", ready,
    })).catch(() => debugLog("shopifyContext", "publish unavailable"));
  } catch {
    debugLog("shopifyContext", "publish unavailable");
  }
}
